<template>
	<footer class="footer">
		<div class="footer-content">
			<!-- <div class="footer-section">
				<h3>{{ $t('footer.brandCooperation') }}</h3>
				<ul>
					<li>
						<a href="#" @click.prevent="handleClick('加盟合作')">{{ $t('footer.joinOfflineStore') }}</a>
					</li>
					<li>
						<a href="https://www.vtimes.net.cn/vtimesPhpAdmin/login.php">{{ $t('footer.StaffOnly') }}</a>
					</li>
				</ul>
			</div> -->
			<div class="footer-section">
				<h3>{{ $t('footer.aboutUs') }}</h3>
				<ul>
					<li>
						<a href="#" @click.prevent="handleClick('公司简介')">{{ $t('footer.companyIntro') }}</a>
					</li>
					<li>
						<a href="#" @click.prevent="handleClick('企业文化')">{{ $t('footer.companyCulture') }}</a>
					</li>
					<li>
						<a href="#" @click.prevent="handleClick('核心优势')">{{ $t('footer.coreAdvantages') }}</a>
					</li>
					<li>
						<a href="#" @click.prevent="handleClick('研发成果')">{{ $t('footer.researchResults') }}</a>
					</li>
					<li>
						<a href="#" @click.prevent="handleClick('合作伙伴')">{{ $t('footer.partners') }}</a>
					</li>
				</ul>
			</div>
			<div class="footer-section">
				<h3>{{ $t('footer.serviceSupport') }}</h3>
				<ul>
					<li>
						<a href="#" @click.prevent="handleClick('服务网点')">{{ $t('footer.serviceNetwork') }}</a>
					</li>
				</ul>
			</div>
			<div class="footer-section">
				<h3>{{ $t('footer.contactUs') }}</h3>
				<p>{{ $t('footer.email') }}：{{ footerData.email }}</p>
				<p>{{ $t('footer.serviceHotline') }}：{{ footerData.serviceHotline }}</p>
				<p>{{ $t('footer.address') }}：{{$i18n.locale == 'zh-CN' ? footerData.address : footerData.addressEN }}</p>
				<div class="qr-codes">
					<div class="qr-code">
						<img :src="footerData.wechatQR" alt="微信公众号" />
						<p>{{ $t('footer.wechatOfficialAccount') }}</p>
					</div>
					<div class="qr-code">
						<img :src="footerData.douyinQR" alt="抖音号" />
						<p>{{ $t('footer.douyinAccount') }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bottom">
			<p v-if="$i18n.locale == 'zh-CN'">深圳市唯泰斯智能科技有限公司 网站备案:【粤ICP备2024314850号】</p>
			<div class="language-selector" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
				<i class="fas fa-globe"></i>
				<span>{{ $t('language') }}</span>
				<i class="fas fa-chevron-down chevron-down" :class="{ rotate: showDropdown }"></i>
				<div class="language-dropdown" v-show="showDropdown">
					<a href="#" class="language-option" @click.prevent="changeLanguage('zh-CN')">简体中文</a>
					<a href="#" class="language-option" @click.prevent="changeLanguage('en')">English</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import { footerInfoApi, baseImgUrl } from '../netTool/api.js';

export default {
	name: 'AppFooter',
	data() {
		return {
			showDropdown: false,
			footerData: {
				email: '',
				serviceHotline: '',
				address: '',
				wechatQR: '',
				douyinQR: ''
			}
		};
	},
	mounted() {
		this.getFooterInfo();
	},
	methods: {
		async getFooterInfo() {
			try {
				const response = await footerInfoApi.getFooterData();
				if (response.success) {
					this.footerData = {
						email: response.data.email,
						serviceHotline: response.data.serviceHotline,
						address: response.data.address,
						addressEN: response.data.address_en,
						wechatQR: baseImgUrl + response.data.wechatOfficialAccount,
						douyinQR: baseImgUrl + response.data.douyinAccount
					};
				}
			} catch (error) {
				console.error('获取页脚信息失败:', error);
			}
		},

		handleClick(type) {
			console.log('Clicked:', type);
		},
		changeLanguage(lang) {
			this.$i18n.locale = lang;
		}
	}
};
</script>

<style scoped>
.footer {
	background-color: #f5f5f5;
	color: #666;
	padding-top: 35px;
	padding-bottom: 20px;
}

.footer-content {
	display: flex;
	justify-content: space-around;
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 20px;
}

.footer-section {
	flex: 1;
	margin: 0 10px;
}

.footer-section h3 {
	font-size: 16px;
	margin-bottom: 15px;
}

.footer-section ul {
	list-style: none;
	padding: 0;
}

.footer-section ul li a {
	font-size: 14px;
	margin-bottom: 10px;
	display: block;
	color: #666;
	text-decoration: none;
}

.footer-section ul li a:hover {
	color: #000;
}

.qr-codes {
	display: flex;
	margin-top: 12px;
}

.qr-code {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 15px;
}

.qr-code img {
	width: 80px;
	height: 80px;
}

.footer-bottom {
	display: flex;
	justify-content: space-between;
	align-items: center;
	max-width: 1200px;
	margin: 20px auto 0;
	padding: 0 20px;
	font-size: 12px;
	border-top: 1px solid #ddd;
	padding-top: 10px;
}

.language-selector {
	display: flex;
	align-items: center;
	cursor: pointer;
	position: relative;
}

.language-dropdown {
	width: 120px;
	height: 70px;
	position: absolute;
	top: -70px;
	right: 0px;
	background: white;
	border: 1px solid #ddd;
	padding: 5px;
	z-index: 100;
}

.language-option {
	display: block;
	padding: 5px 10px;
	color: #666;
	text-decoration: none;
}

.language-option:hover {
	background: #f5f5f5;
}

.rotate {
	transform: rotate(180deg);
}

@media (max-width: 768px) {
	.footer {
		padding: 30px 15px; /* 增加移动端 padding */
	}

	.footer-content {
		flex-direction: column; /* 改为垂直布局 */
		padding: 0;
	}

	.footer-section {
		margin: 0 0 25px 0; /* 调整间距 */
		width: 100%; /* 占满宽度 */
	}

	.footer-section:last-child {
		margin-bottom: 0;
	}

	.footer-section h3 {
		font-size: 16px; /* 增大标题字体 */
		margin-bottom: 12px;
	}

	.footer-section ul li a {
		font-size: 14px; /* 增大链接字体 */
		margin-bottom: 8px;
	}

	.qr-codes {
		margin-top: 15px;
		flex-wrap: wrap; /* 允许二维码换行 */
	}

	.qr-code {
		margin-right: 12px;
		margin-bottom: 12px;
	}

	.qr-code img {
		width: 90px; /* 调整二维码大小 */
		height: 90px;
	}

	.footer-bottom {
		flex-direction: column; /* 底部改为垂直布局 */
		align-items: flex-start; /* 左对齐 */
		padding-top: 20px;
		margin-top: 20px;
	}

	.language-selector {
		margin-top: 15px; /* 增加语言选择器间距 */
	}
}

/* 超小屏幕（480px 以下）进一步优化 */
@media (max-width: 480px) {
	.qr-code img {
		width: 80px; /* 进一步缩小二维码 */
		height: 80px;
	}

	.footer-section h3 {
		font-size: 15px;
	}

	.footer-section ul li a {
		font-size: 13px;
	}
}
</style>
